// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dFOl","question":"styles_question__143Dy","description":"styles_description__KL1Fo"};